import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { User } from 'src/app/models/user';
import { LoggingService } from 'src/app/services/logging.service';
import { IdentityWhitelabelApiClient } from 'src/app/services/api-clients/identity-whitelabel.api-client';
import { SettingsService } from '../../settings.service';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { Subscription, lastValueFrom } from 'rxjs';
import { EditOrganisationModal } from '../../edit-organisation/edit-organisation.modal';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { ToastService } from 'src/app/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { IdsForSettingsService } from '../../ids-for-settings.service';


@Component({
  templateUrl: './settings-whitelabel-organisations.page.html'
})
export class SettingsWhitelabelOrganisationsPage implements OnInit {
  organisations: any[] = [];
  user!: User;
  selectedWhiteLabelId: string = "";
  whiteLabelIdSubscription: Subscription = new Subscription();

  constructor(private modalService: NgbModal,
    private loggingService: LoggingService,
    private identityWhitelabelService: IdentityWhitelabelApiClient,
    private settingsService: SettingsService,
    private idsForSettingsService: IdsForSettingsService,
    private settingsBreadCrumbService: SettingsBreadCrumbService,
    private identityOrganisationService: IdentityOrganisationApiClient,
    private toastService: ToastService,
    private translateService: TranslateService) {
    this.user = this.settingsService.user;
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
    this.whiteLabelIdSubscription = this.idsForSettingsService.selectedWhiteLabelId$.subscribe(whiteLabelId => {
      if (whiteLabelId === this.selectedWhiteLabelId) return;
      this.selectedWhiteLabelId = whiteLabelId;

      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetWhiteLabelCrumbs(BreadCrumbOptions.Whitelabel_Organisations(this.selectedWhiteLabelId));

      if (whiteLabelId !== null || whiteLabelId !== undefined || whiteLabelId !== "") {
        this.identityWhitelabelService.getOrganisations(whiteLabelId).subscribe({
          next: (data: any) => {
            this.organisations = [];
            data.forEach((org: any) => {
              this.organisations.push(org.organisation);
            });
            this.remainingOrganisations = this.settingsService.whiteLabel.whiteLabel.maxOrganisationCount - this.organisations.length;
          }
        });
      }
    });
  }

  hover: boolean = false;
  remainingOrganisations: number = 0;
  filter: string = '';
  users: User[] = [];
  translations = <any>{};

  getTranslations() {
    this.translateService.get([
      'Toasts.AddOrganisationError',
      'Toasts.Error',
    ]).subscribe(translation => {
      this.translations.toastsAddOrganisationError = translation['Toasts.AddOrganisationError'];
      this.translations.error = translation['Toasts.Error'];

    });
  }

  async ngOnInit(): Promise<void> {
  }

  applyFilter(event: Event) {
    this.filter = (event.target as HTMLInputElement).value;
  }

  addOrganisation() {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      windowClass: 'dialog-bg-white',
      backdrop: 'static'
    };
    const modalRef = this.modalService.open(EditOrganisationModal, ngbModalOptions);
    modalRef.componentInstance.updateOrganisation.subscribe(async (data: any) => {
      data.organisation.organisation.enterprise = {};
      data.organisation.organisation.enterprise.guid = this.selectedWhiteLabelId;
      await this.identityOrganisationService.addOrganisation(data.organisation.organisation)
        .then(result => {
          lastValueFrom(result)
            .then((organisationId: any) => {
              this.toastService.showSaved();
              if (!data.organisation.organisation.whitelabelEnabled) {
                this.settingsService.updateBrandingStatus("disable",data.organisation.organisation, false);
              }
              this.identityWhitelabelService.getOrganisations(this.selectedWhiteLabelId).subscribe({
                next: (data: any) => {
                  this.organisations = [];
                  data.forEach((org: any) => {
                    this.organisations.push(org.organisation);
                  });
                }
              });
            })
            .catch((error) => {
              this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsAddOrganisationError + "");
            });
        })
        .catch((error) => this.loggingService.logException(error));;

      modalRef.close();
    });
  }

  async TriggerRefresh() {
    this.identityWhitelabelService.getOrganisations(this.selectedWhiteLabelId).subscribe({
      next: (data: any) => {
        this.organisations = [];
        data.forEach((org: any) => {
          this.organisations.push(org.organisation);
        });
      }
    });
  }
}
